import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: 'var(--bg)',
          color: 'var(--text)',
          fontFamily: 'var(--ff-u)',
          padding: '20px'
        }}>
          <div style={{
            background: 'var(--bg2)',
            border: '1px solid var(--line2)',
            borderRadius: 'var(--r2)',
            padding: '40px',
            textAlign: 'center',
            maxWidth: '500px'
          }}>
            <h2 style={{
              color: 'var(--coral2)',
              marginBottom: '20px',
              fontFamily: 'var(--ff-d)'
            }}>
              Something went wrong
            </h2>
            <p style={{
              color: 'var(--text2)',
              marginBottom: '20px',
              lineHeight: '1.6'
            }}>
              ResultOS encountered an unexpected error. Please refresh the page to try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, var(--gold3), var(--gold))',
                border: 'none',
                borderRadius: 'var(--r)',
                color: '#0A0800',
                padding: '12px 24px',
                fontFamily: 'var(--ff-u)',
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && (
              <details style={{ marginTop: '20px', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: 'var(--text3)' }}>
                  Error Details (Development)
                </summary>
                <pre style={{
                  background: 'var(--bg3)',
                  padding: '10px',
                  borderRadius: 'var(--r)',
                  fontSize: '12px',
                  color: 'var(--coral2)',
                  overflow: 'auto',
                  marginTop: '10px'
                }}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary